require("!!/usr/src/app/node_modules/script-loader/addScript.js")(require("!!/usr/src/app/node_modules/raw-loader/index.js!/usr/src/app/scripts/VisitorAPI.js"))